import React, { Fragment, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import clsx from 'clsx';
import { Link } from 'react-router-dom';
import PageTitle from '../../shared/components/PageTitle';

import {
  Hidden,
  IconButton,
  AppBar,
  Box,
  Tooltip,
  FormControl,
  MenuItem,
  Select,
  InputLabel
} from '@mui/material';

import { connect } from 'react-redux';
import { setSidebarToggleMobile } from '../../reducers/ThemeOptions';
import HeaderLogo from '../../layout-components/HeaderLogo';
import HeaderUserbox from '../../layout-components/HeaderUserbox';
import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';

const Header = props => {
  const toggleSidebarMobile = () => {
    setSidebarToggleMobile(!sidebarToggleMobile);
  };
  const {
    headerShadow,
    headerFixed,
    sidebarToggleMobile,
    setSidebarToggleMobile,
    onRangeChange,
  } = props;

  const location = useLocation();
  const isDashboard = location.pathname.toLowerCase() === "/dashboard"

  var [range, setRange] = React.useState("MONTH");

  const rangeOption = [
    { id: "DAILY", range: "Daily" },
    { id: "WEEK", range: "This Week" },
    { id: "BI_WEEK", range: "Bi-Week " },
    { id: "MONTH", range: "This Month" },
    { id: "QUARTER", range: "This Quarter" },
    { id: "YEAR", range: "This Year" }
  ];

  const userProfile = localStorage.getItem("userProfile");

  return (
    <Fragment>
      <AppBar
        color="secondary"
        className={clsx('app-header', {}, "headerOverrideCss")}
        position={headerFixed ? 'fixed' : 'absolute'}
        elevation={headerShadow ? 11 : 3}>
        {!props.isCollapsedLayout && <HeaderLogo />}
        <Box
          className="app-header-toolbar d-flex align-items-center justify-content-between w-100"
        >
          <Hidden lgUp>
            <Box
              className="app-logo-wrapper"
              title="Mobile Surety">
              <Link
                // to="/Dashboard" 
                className="app-logo-link"
              >
              </Link>

            </Box>
          </Hidden>
          <Hidden mdDown>
            <Box className="d-flex align-items-center">
            </Box>
          </Hidden>

          {isDashboard && (
            <Box className="d-flex align-items-center" style={{ width: "100%" }}>
              <PageTitle>Dashboard</PageTitle>
              <Box className="d-flex justify-content-center" style={{ width: "100%" }} >
                <div style={{ position: "relative", width: "180px" }}>
                  <FormControl style={{ width: 180 }} size="small">
                    <InputLabel id="range">Select Range</InputLabel>
                    <Select
                      labelId="range"
                      id="range"
                      value={range}
                      label="Select Label"
                      onChange={(e) => {
                        const value = e.target.value
                        setRange(value);
                        onRangeChange(value);
                      }}>
                      {rangeOption.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.range}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </Box>
            </Box>
          )}

          {userProfile && (
            <Box className="d-flex align-items-center">
              <HeaderUserbox />
              <Box>
                <Tooltip title="Toggle Sidebar" placement="right">
                  <IconButton
                    // color="inherit"
                    onClick={toggleSidebarMobile}
                    size="medium">
                    {sidebarToggleMobile ? (
                      <MenuOpenRoundedIcon />
                    ) : (
                      <MenuRoundedIcon />
                    )}
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          )}
        </Box>
      </AppBar>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  headerShadow: state.ThemeOptions.headerShadow,
  headerFixed: state.ThemeOptions.headerFixed,
  sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile
});

const mapDispatchToProps = dispatch => ({
  setSidebarToggleMobile: enable => dispatch(setSidebarToggleMobile(enable))
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
